export const CommonI18N = {
    header: {
        action: {
            createRequest: "common.header.action.createRequest",
            logout: "common.header.action.logout",
            signIn: "common.header.action.signIn",
            operatorRequests: "common.header.action.operatorRequests",
            company: "common.header.action.company",
            cartonGradeImports: "common.header.action.cartonGradeImports",
            addresses: "common.header.action.addresses",
            languageFiles: "common.header.action.languageFiles",
            myProfile: "common.header.action.myProfile",
            myCompany: "common.header.action.myCompany",
            adminConsole: "common.header.action.adminConsole",
            logViewer: "common.header.action.logViewer",
            changePassword: "common.header.action.changePassword", // NOSONAR
            switchCompany: "common.header.action.switchCompany",
            bidderOverview: "common.header.action.bidderOverview",
            requesterOverview: "common.header.action.requesterOverview",
            selectLanguage: "common.header.action.selectLanguage"
        },
        message: {
            logout: "common.header.message.logout"
        }
    },
    footer: {
        initiative: "common.footer.initiative",
        contact: "common.footer.contact",
        contactPerson: "common.footer.contactPerson",
        legal: "common.footer.legal",
        imprint: "common.footer.imprint",
        privacy: "common.footer.privacy",
        cookieSettings: "common.footer.cookieSettings",
        memberArea: "common.footer.memberArea"
    },
    action: {
        close: "common.action.close",
        cancel: "common.action.cancel",
        save: "common.action.save",
        refresh: "common.action.refresh",
        clear: "common.action.clear",
        uploadImageOrPdf: "common.action.uploadImageOrPdf",
        toHomepage: "common.action.toHomepage"
    },
    message: {
        unknownError: "common.message.unknownError",
        pleaseSelect: "common.message.pleaseSelect",
        notGiven: "common.message.notGiven",
        yes: "common.message.yes",
        no: "common.message.no",
        sessionExpiredSummary: "common.message.sessionExpiredSummary",
        sessionExpiredDetails: "common.message.sessionExpiredDetails",
        accessDeniedSummary: "common.message.accessDeniedSummary",
        accessDeniedDetails: "common.message.accessDeniedDetails",
        accessDeniedWAFSummary: "common.message.accessDeniedWAFSummary",
        accessDeniedWAFDetails: "common.message.accessDeniedWAFDetails",
        loaded: "common.message.loaded",
        loadFailed: "common.message.loadFailed",
        resourceNotFound: "common.message.resourceNotFound",
        saved: "common.message.saved",
        saveFailed: "common.message.saveFailed",
        validationError: "common.message.validationError",
        downloadFailed: "common.message.downloadFailed",
        downloadInProgress: "common.message.downloadInProgress",
        downloadInProgressDetails: "common.message.downloadInProgressDetails",
        contentTooLargeSummary: "common.message.contentTooLargeSummary",
        contentTooLargeDetails: "common.message.contentTooLargeDetails",
        uploadLimit: "common.message.uploadLimit",
        uploadInProgress: "common.message.uploadInProgress",
        documentLoadFailed: "common.message.documentLoadFailed",
        documentLoadFailedSupport: "common.message.documentLoadFailedSupport"
    },
    field: {
        hour: "common.field.hour",
        minute: "common.field.minute",
        second: "common.field.second",
        status: "common.field.status"
    },
    snackbar: {
        action: {
            details: "common.snackbar.action.details"
        }
    },
    enum: {
        companyStatus: {
            OPERATOR: "common.enum.companyStatus.OPERATOR",
            INVITED: "common.enum.companyStatus.INVITED",
            UNVERIFIED: "common.enum.companyStatus.UNVERIFIED",
            CONFIRMED: "common.enum.companyStatus.CONFIRMED",
            TERMINATION_RECEIVED: "common.enum.companyStatus.TERMINATION_RECEIVED",
            TERMINATION_RECEIVED_LOCKED: "common.enum.companyStatus.TERMINATION_RECEIVED_LOCKED",
            TERMINATED: "common.enum.companyStatus.TERMINATED",
            REJECTED: "common.enum.companyStatus.REJECTED",
            CONFIRMED_LOCKED: "common.enum.companyStatus.CONFIRMED_LOCKED",
            ARCHIVED: "common.enum.companyStatus.ARCHIVED"
        },
        country: {
            GERMANY: "common.enum.country.GERMANY",
            NETHERLANDS: "common.enum.country.NETHERLANDS",
            AUSTRIA: "common.enum.country.AUSTRIA",
            SWITZERLAND: "common.enum.country.SWITZERLAND",
            CZECHIA: "common.enum.country.CZECHIA",
            POLAND: "common.enum.country.POLAND",
            ITALY: "common.enum.country.ITALY",
            FRANCE: "common.enum.country.FRANCE"
        },
        salutation: {
            MR: "common.enum.salutation.MR",
            MS: "common.enum.salutation.MS",
            DR_MALE: "common.enum.salutation.DR_MALE",
            DR_FEMALE: "common.enum.salutation.DR_FEMALE",
            PROF_MALE: "common.enum.salutation.PROF_MALE",
            PROF_FEMALE: "common.enum.salutation.PROF_FEMALE",
            DIVERS: "common.enum.salutation.DIVERS"
        },
        language: {
            GERMAN: "common.enum.language.GERMAN",
            ENGLISH: "common.enum.language.ENGLISH",
            POLISH: "common.enum.language.POLISH",
            ITALIAN: "common.enum.language.ITALIAN",
            FRENCH: "common.enum.language.FRENCH",
            CZECH: "common.enum.language.CZECH"
        },
        companyMembershipStatus: {
            INVITED: "common.enum.companyMembershipStatus.INVITED",
            INVITED_LOCKED: "common.enum.companyMembershipStatus.INVITED_LOCKED",
            CONFIRMED: "common.enum.companyMembershipStatus.CONFIRMED",
            CONFIRMED_LOCKED: "common.enum.companyMembershipStatus.CONFIRMED_LOCKED",
            DEACTIVATED: "common.enum.companyMembershipStatus.DEACTIVATED"
        },
        terminationInitiator: {
            CLIENT: "common.enum.terminationInitiator.CLIENT",
            OPERATOR: "common.enum.terminationInitiator.OPERATOR"
        },
        requestStatus: {
            DRAFT: "common.enum.requestStatus.DRAFT",
            CREATED: "common.enum.requestStatus.CREATED",
            PUBLISHED: "common.enum.requestStatus.PUBLISHED",
            TO_BE_CONFIRMED: "common.enum.requestStatus.TO_BE_CONFIRMED",
            CONFIRMED: "common.enum.requestStatus.CONFIRMED",
            DEACTIVATED: "common.enum.requestStatus.DEACTIVATED",
            CANCELLED: "common.enum.requestStatus.CANCELLED",
            IN_NEGOTIATION: "common.enum.requestStatus.IN_NEGOTIATION"
        },
        quoteStatus: {
            NOT_VACANT: "common.enum.quoteStatus.NOT_VACANT",
            VACANT: "common.enum.quoteStatus.VACANT",
            SUBMITTED: "common.enum.quoteStatus.SUBMITTED",
            ACCEPTED: "common.enum.quoteStatus.ACCEPTED",
            DISMISSED: "common.enum.quoteStatus.DISMISSED",
            REJECTED: "common.enum.quoteStatus.REJECTED",
            IN_NEGOTIATION: "common.enum.quoteStatus.IN_NEGOTIATION"
        },
        calculationStatus: {
            PENDING: "common.enum.calculationStatus.PENDING",
            CALCULATED: "common.enum.calculationStatus.CALCULATED",
            ERROR: "common.enum.calculationStatus.ERROR"
        },
        palletType: {
            EURO_PALLET_NEW: "common.enum.palletType.EURO_PALLET_NEW",
            EURO_PALLET_NW: "common.enum.palletType.EURO_PALLET_NW",
            EURO_PALLET_USED: "common.enum.palletType.EURO_PALLET_USED",
            INDUSTRY_PALLET: "common.enum.palletType.INDUSTRY_PALLET",
            ONE_WAY_PALLET: "common.enum.palletType.ONE_WAY_PALLET",
            EURO_PALLET_ONE_WAY: "common.enum.palletType.EURO_PALLET_ONE_WAY",
            INDUSTRY_PALLET_ONE_WAY: "common.enum.palletType.INDUSTRY_PALLET_ONE_WAY"
        },
        printType: {
            NO_PRINT: "common.enum.printType.NO_PRINT",
            FULL_AREA_PRINT: "common.enum.printType.FULL_AREA_PRINT",
            WARNING_PRINT: "common.enum.printType.WARNING_PRINT"
        },
        numberOfPallet: {
            ONE_ON_THE_SIDE: "common.enum.numberOfPallet.ONE_ON_THE_SIDE",
            ONE_ON_THE_LONG_AND_SHORT_SIDE: "common.enum.numberOfPallet.ONE_ON_THE_LONG_AND_SHORT_SIDE",
            ON_ALL_FOUR_SIDES: "common.enum.numberOfPallet.ON_ALL_FOUR_SIDES"
        },
        cardinalDirection: {
            N: "common.enum.cardinalDirection.N",
            NE: "common.enum.cardinalDirection.NE",
            E: "common.enum.cardinalDirection.E",
            SE: "common.enum.cardinalDirection.SE",
            S: "common.enum.cardinalDirection.S",
            SW: "common.enum.cardinalDirection.SW",
            W: "common.enum.cardinalDirection.W",
            NW: "common.enum.cardinalDirection.NW"
        },
        emailStatus: {
            SENT: "common.enum.emailStatus.SENT",
            ERROR: "common.enum.emailStatus.ERROR",
            NOT_SENT: "common.enum.emailStatus.NOT_SENT"
        },
        legalForm: {
            AG: "common.enum.legalForm.AG",
            AG_KG: "common.enum.legalForm.AG_KG",
            AG_Co_KGaA: "common.enum.legalForm.AG_Co_KGaA",
            AG_Co_OHG: "common.enum.legalForm.AG_Co_OHG",
            gAG: "common.enum.legalForm.gAG",
            GbR: "common.enum.legalForm.GbR",
            GmbH: "common.enum.legalForm.GmbH",
            GmbH_Co_KG: "common.enum.legalForm.GmbH_Co_KG",
            GmbH_Co_KGaA: "common.enum.legalForm.GmbH_Co_KGaA",
            GmbH_Co_OHG: "common.enum.legalForm.GmbH_Co_OHG",
            GmbHG: "common.enum.legalForm.GmbHG",
            KG: "common.enum.legalForm.KG",
            KGaA: "common.enum.legalForm.KGaA",
            KGaA_Co_KG: "common.enum.legalForm.KGaA_Co_KG",
            OHG: "common.enum.legalForm.OHG",
            OHG_mbh: "common.enum.legalForm.OHG_mbh",
            PartG: "common.enum.legalForm.PartG",
            PartG_mbB: "common.enum.legalForm.PartG_mbB",
            Sonstige: "common.enum.legalForm.Sonstige",
            Stiftung_Co_KG: "common.enum.legalForm.Stiftung_Co_KG",
            UG_h: "common.enum.legalForm.UG_h",
            UG_hCo_KG: "common.enum.legalForm.UG_hCo_KG",
            SE: "common.enum.legalForm.SE",
            Einzelunternehmer: "common.enum.legalForm.Einzelunternehmer",
            Eingetragenes_Unternehmen: "common.enum.legalForm.Eingetragenes_Unternehmen",
            Besloten_Vennootschap: "common.enum.legalForm.Besloten_Vennootschap",
            Naamloze_Vennootschap: "common.enum.legalForm.Naamloze_Vennootschap",
            Vennootschap_Onder_Firma: "common.enum.legalForm.Vennootschap_Onder_Firma",
            Commanditaire_Vennootschap: "common.enum.legalForm.Commanditaire_Vennootschap",
            Maatschap: "common.enum.legalForm.Maatschap",
            Eenmanszaak: "common.enum.legalForm.Eenmanszaak",
            CH_Kollektivgesellschaft: "common.enum.legalForm.CH_Kollektivgesellschaft",
            CH_Kommanditgesellschaft: "common.enum.legalForm.CH_Kommanditgesellschaft",
            CH_Einzelunternehmen: "common.enum.legalForm.CH_Einzelunternehmen",
            CH_Genossenschaft: "common.enum.legalForm.CH_Genossenschaft",
            CZ_s_r_o: "common.enum.legalForm.CZ_s_r_o",
            CZ_a_s: "common.enum.legalForm.CZ_a_s",
            CZ_k_s: "common.enum.legalForm.CZ_k_s",
            CZ_v_o_s: "common.enum.legalForm.CZ_v_o_s",
            CZ_Druzstvo: "common.enum.legalForm.CZ_Druzstvo",
            CZ_OSVC: "common.enum.legalForm.CZ_OSVC",
            PL_Sp_z_o_o: "common.enum.legalForm.PL_Sp_z_o_o",
            PL_S_A: "common.enum.legalForm.PL_S_A",
            PL_Sp_k: "common.enum.legalForm.PL_Sp_k",
            PL_Sp_j: "common.enum.legalForm.PL_Sp_j",
            PL_Sp_p: "common.enum.legalForm.PL_Sp_p",
            PL_PSA: "common.enum.legalForm.PL_PSA",
            PL_JDG: "common.enum.legalForm.PL_JDG",
            IT_S_r_l: "common.enum.legalForm.IT_S_r_l",
            IT_S_r_l_s: "common.enum.legalForm.IT_S_r_l_s",
            IT_S_p_A: "common.enum.legalForm.IT_S_p_A",
            IT_S_a_p_A: "common.enum.legalForm.IT_S_a_p_A",
            IT_S_n_c: "common.enum.legalForm.IT_S_n_c",
            IT_S_a_s: "common.enum.legalForm.IT_S_a_s",
            IT_Soc_coop: "common.enum.legalForm.IT_Soc_coop",
            IT_Ditta_individuale: "common.enum.legalForm.IT_Ditta_individuale",
            FR_SARL: "common.enum.legalForm.FR_SARL",
            FR_EURL: "common.enum.legalForm.FR_EURL",
            FR_SAS: "common.enum.legalForm.FR_SAS",
            FR_SASU: "common.enum.legalForm.FR_SASU",
            FR_SA: "common.enum.legalForm.FR_SA",
            FR_SNC: "common.enum.legalForm.FR_SNC",
            FR_SCS: "common.enum.legalForm.FR_SCS",
            FR_SCA: "common.enum.legalForm.FR_SCA",
            FR_EI: "common.enum.legalForm.FR_EI"
        },
        orderStatus: {
            PENDING: "common.enum.orderStatus.PENDING",
            ORDER_CONFIRMED: "common.enum.orderStatus.ORDER_CONFIRMED",
            DELIVERY_DATE_PROPOSED: "common.enum.orderStatus.DELIVERY_DATE_PROPOSED",
            DELIVERY_DATE_CONFIRMED: "common.enum.orderStatus.DELIVERY_DATE_CONFIRMED",
            DELIVERED: "common.enum.orderStatus.DELIVERED",
            CANCELLED_BY_SUPPLIER: "common.enum.orderStatus.CANCELLED_BY_SUPPLIER",
            CANCELLED_BY_REQUESTER: "common.enum.orderStatus.CANCELLED_BY_REQUESTER",
            DEACTIVATED: "common.enum.orderStatus.DEACTIVATED"
        }
    }
};

export const AuthI18N = {
  userSignup: {
    page: {
      title: "auth.userSignup.page.title",
      cardTitle: "auth.userSignup.page.cardTitle"
    },
    form: {
      passwordCardTitle: "auth.userSignup.form.passwordCardTitle" // NOSONAR
    },
    action: {
      submit: "auth.userSignup.action.submit"
    },
    message: {
      failedTitle: "auth.userSignup.message.failedTitle",
      failedSubtitle: "auth.userSignup.message.failedSubtitle"
    }
  },
  confirmCompany: {
    page: {
      description: "auth.confirmCompany.page.description"
    },
    action: {
      confirm: "auth.confirmCompany.action.confirm"
    },
    message: {
      successTitle: "auth.confirmCompany.message.successTitle",
      successSubtitle: "auth.confirmCompany.message.successSubtitle",
      failedTitle: "auth.confirmCompany.message.failedTitle",
      failedSubtitle: "auth.confirmCompany.message.failedSubtitle"
    }
  },
  login: {
    action: {
      login: "auth.login.action.login",
      continue: "auth.login.action.continue",
      finish: "auth.login.action.finish",
      goToHome: "auth.login.action.goToHome",
      back: "auth.login.action.back",
      passwordForgotten: "auth.login.action.passwordForgotten" // NOSONAR
    },
    page: {
      loginMessage: "auth.login.page.loginMessage",
      description: "auth.login.page.description",
      signUpTitle: "auth.login.page.signUpTitle",
      addressDataTitle: "auth.login.page.addressDataTitle"
    },
    field: {
      termsAgreement: "auth.login.field.termsAgreement",
      privacyPolicy: "auth.login.field.privacyPolicy",
      confidentialityAgreement: "auth.login.field.confidentialityAgreement",
      termsAndConditions: "auth.login.field.termsAndConditions"
    },
    message: {
      scrollDown: "auth.login.message.scrollDown",
      registrationSuccess: "auth.login.message.registrationSuccess",
      registrationUnderReview: "auth.login.message.registrationUnderReview",
      registrationFailed: "auth.login.message.registrationFailed",
      registrationFailedDescription: "auth.login.message.registrationFailedDescription",
      loginFailedSummary: "auth.login.message.loginFailedSummary",
      loginFailed: "auth.login.message.loginFailed",
      privacyPolicyLoadFailed: "auth.login.message.privacyPolicyLoadFailed",
      confidentialityLoadFailed: "auth.login.message.confidentialityLoadFailed",
      termsAndConditionsLoadFailed: "auth.login.message.termsAndConditionsLoadFailed",
      expiringSoonRequestHint: "auth.login.message.expiringSoonRequestHint",
      expiringSoonRequestHintLink: "auth.login.message.expiringSoonRequestHintLink",
      loginLocked: "auth.login.message.loginLocked"
    },
    validation: {
      privacyPolicyRequired: "auth.login.validation.privacyPolicyRequired",
      confidentialityRequired: "auth.login.validation.confidentialityRequired",
      contractAndUsageRequired: "auth.login.validation.contractAndUsageRequired"
    }
  }
};

export const AdminI18N = {
    companies: {
        page: {
            registrationRequestsTitle: "admin.companies.page.registrationRequestsTitle",
            title: "admin.companies.page.title",
            usersTitle: "admin.companies.page.usersTitle"
        },
        column: {
            name: "admin.companies.column.name",
            groupName: "admin.companies.column.groupName",
            tenant: "admin.companies.column.tenant",
            postalCode: "admin.companies.column.postalCode",
            country: "admin.companies.column.country",
            lastActivity: "admin.companies.column.lastActivity",
            requestsTooltip: "admin.companies.column.requestsTooltip",
            quotesTooltip: "admin.companies.column.quotesTooltip",
            bidderInteractionsTooltip: "admin.companies.column.bidderInteractionsTooltip",
            status: "admin.companies.column.status",
            statusDate: "admin.companies.column.statusDate",
            isCEO: "admin.companies.column.isCEO",
            userStatus: "admin.companies.column.userStatus"
        },
        statusEvent: {
            invited: "admin.companies.statusEvent.invited",
            invitedWithoutActor: "admin.companies.statusEvent.invitedWithoutActor",
            registered: "admin.companies.statusEvent.registered",
            confirmed: "admin.companies.statusEvent.confirmed",
            confirmedWithoutActor: "admin.companies.statusEvent.confirmedWithoutActor",
            terminatedAutomatic: "admin.companies.statusEvent.terminatedAutomatic"
        },
        action: {
            invite: "admin.companies.action.invite",
            unlockForEditing: "admin.companies.action.unlockForEditing",
            lockEditing: "admin.companies.action.lockEditing",
            approveSignupRequest: "admin.companies.action.approveSignupRequest",
            rejectSignupRequest: "admin.companies.action.rejectSignupRequest",
            saveChanges: "admin.companies.action.saveChanges",
            resendInvitation: "admin.companies.action.resendInvitation",
            delete: "admin.companies.action.delete",
            confirmDelete: "admin.companies.action.confirmDelete",
            createTenant: "admin.companies.action.createTenant",
            archive: "admin.companies.action.archive",
            copyLink: "admin.companies.action.copyLink",
            inviteSubmit: "admin.companies.action.inviteSubmit"
        },
        message: {
            notFound: "admin.companies.message.notFound",
            searchFailed: "admin.companies.message.searchFailed",
            approveSuccess: "admin.companies.message.approveSuccess",
            approveFailed: "admin.companies.message.approveFailed",
            rejectSuccess: "admin.companies.message.rejectSuccess",
            rejectFailed: "admin.companies.message.rejectFailed",
            noEmployeesFound: "admin.companies.message.noEmployeesFound",
            resendInvitationSuccess: "admin.companies.message.resendInvitationSuccess",
            resendInvitationFailed: "admin.companies.message.resendInvitationFailed",
            deleteSuccess: "admin.companies.message.deleteSuccess",
            deleteFailed: "admin.companies.message.deleteFailed",
            archiveSuccess: "admin.companies.message.archiveSuccess",
            archiveFailed: "admin.companies.message.archiveFailed",
            invitationSent: "admin.companies.message.invitationSent"
        },
        label: {
            requests: "admin.companies.label.requests",
            quotes: "admin.companies.label.quotes",
            bidderInteractions: "admin.companies.label.bidderInteractions",
            company: "admin.companies.label.company"
        },
        dialog: {
            resendInvitationTitle: "admin.companies.dialog.resendInvitationTitle",
            deleteTitle: "admin.companies.dialog.deleteTitle",
            deleteMessage: "admin.companies.dialog.deleteMessage",
            createTenantTitle: "admin.companies.dialog.createTenantTitle",
            archiveTitle: "admin.companies.dialog.archiveTitle",
            archiveMessage: "admin.companies.dialog.archiveMessage"
        },
        field: {
            tenantName: "admin.companies.field.tenantName",
            tenant: "admin.companies.field.tenant"
        },
        validation: {
            tenantNameRequired: "admin.companies.validation.tenantNameRequired",
            tenantNameMin: "admin.companies.validation.tenantNameMin",
            tenantNameMax: "admin.companies.validation.tenantNameMax"
        }
    },
    companyRelationships: {
        page: {
            title: "admin.companyRelationships.page.title"
        },
        filter: {
            name: "admin.companyRelationships.filter.name",
            status: "admin.companyRelationships.filter.status",
            country: "admin.companyRelationships.filter.country",
            countryAll: "admin.companyRelationships.filter.countryAll"
        },
        status: {
            all: "admin.companyRelationships.status.all",
            whitelist: "admin.companyRelationships.status.whitelist",
            blacklist: "admin.companyRelationships.status.blacklist",
            desiredWhitelist: "admin.companyRelationships.status.desiredWhitelist"
        },
        dialog: {
            confirmTitle: "admin.companyRelationships.dialog.confirmTitle",
            confirmMessage: "admin.companyRelationships.dialog.confirmMessage",
            confirmMessageBlacklist: "admin.companyRelationships.dialog.confirmMessageBlacklist",
            confirmMessageWhitelist: "admin.companyRelationships.dialog.confirmMessageWhitelist",
            confirmMessageDesiredWhitelist: "admin.companyRelationships.dialog.confirmMessageDesiredWhitelist",
            confirmMessageWithdrawDesiredWhitelist:
                "admin.companyRelationships.dialog.confirmMessageWithdrawDesiredWhitelist"
        },
        action: {
            blacklist: "admin.companyRelationships.action.blacklist",
            whitelist: "admin.companyRelationships.action.whitelist",
            desiredWhitelist: "admin.companyRelationships.action.desiredWhitelist",
            withdrawDesiredWhitelist: "admin.companyRelationships.action.withdrawDesiredWhitelist"
        },
        field: {
            blacklistedAt: "admin.companyRelationships.field.blacklistedAt",
            effectiveAt: "admin.companyRelationships.field.effectiveAt"
        },
        tooltip: {
            desiredWhitelist: "admin.companyRelationships.tooltip.desiredWhitelist"
        },
        message: {
            loadFailed: "admin.companyRelationships.message.loadFailed",
            updateSuccess: "admin.companyRelationships.message.updateSuccess",
            updateFailed: "admin.companyRelationships.message.updateFailed"
        }
    },
    users: {
        action: {
            delete: "admin.users.action.delete",
            triggerPasswordReset: "admin.users.action.triggerPasswordReset", // NOSONAR
            resendInvitation: "admin.users.action.resendInvitation",
            changeEmail: "admin.users.action.changeEmail"
        },
        dialog: {
            deleteTitle: "admin.users.dialog.deleteTitle",
            deleteMessage: "admin.users.dialog.deleteMessage",
            passwordResetTitle: "admin.users.dialog.passwordResetTitle", // NOSONAR
            passwordResetMessage: "admin.users.dialog.passwordResetMessage", // NOSONAR
            resendInvitationTitle: "admin.users.dialog.resendInvitationTitle",
            resendInvitationMessage: "admin.users.dialog.resendInvitationMessage",
            changeEmailTitle: "admin.users.dialog.changeEmailTitle",
            changeEmailMessage: "admin.users.dialog.changeEmailMessage"
        },
        message: {
            deleteSuccess: "admin.users.message.deleteSuccess",
            passwordResetSuccess: "admin.users.message.passwordResetSuccess", // NOSONAR
            resendInvitationSuccess: "admin.users.message.resendInvitationSuccess",
            resendInvitationFailed: "admin.users.message.resendInvitationFailed",
            changeEmailSuccess: "admin.users.message.changeEmailSuccess",
            changeEmailFailed: "admin.users.message.changeEmailFailed"
        }
    },
    logViewer: {
        action: {
            refresh: "admin.logViewer.action.refresh"
        },
        page: {
            title: "admin.logViewer.page.title"
        },
        message: {
            loadFailed: "admin.logViewer.message.loadFailed",
            noLog: "admin.logViewer.message.noLog"
        },
        field: {
            logFile: "admin.logViewer.field.logFile"
        }
    },
    linkDisplay: {
        dialog: {
            companySignupTitle: "admin.linkDisplay.dialog.companySignupTitle",
            userSignupTitle: "admin.linkDisplay.dialog.userSignupTitle",
            passwordResetTitle: "admin.linkDisplay.dialog.passwordResetTitle" // NOSONAR
        },
        field: {
            validUntil: "admin.linkDisplay.field.validUntil"
        },
        action: {
            copy: "admin.linkDisplay.action.copy"
        },
        message: {
            copySuccess: "admin.linkDisplay.message.copySuccess",
            warning: "admin.linkDisplay.message.warning"
        }
    },
    cartonGradesImport: {
        page: {
            title: "admin.cartonGradesImport.page.title",
            cardTitle: "admin.cartonGradesImport.page.cardTitle",
            importLogTitle: "admin.cartonGradesImport.page.importLogTitle",
            importInfoTitle: "admin.cartonGradesImport.page.importInfoTitle",
            gradesStatisticsTitle: "admin.cartonGradesImport.page.gradesStatisticsTitle",
            plantsStatisticsTitle: "admin.cartonGradesImport.page.plantsStatisticsTitle",
            errorStatusTitle: "admin.cartonGradesImport.page.errorStatusTitle",
            overallStatusTitle: "admin.cartonGradesImport.page.overallStatusTitle"
        },
        action: {
            import: "admin.cartonGradesImport.action.import"
        },
        dialog: {
            confirmTitle: "admin.cartonGradesImport.dialog.confirmTitle",
            confirmMessage: "admin.cartonGradesImport.dialog.confirmMessage"
        },
        message: {
            importFailed: "admin.cartonGradesImport.message.importFailed",
            noGradesFound: "admin.cartonGradesImport.message.noGradesFound",
            statusSuccess: "admin.cartonGradesImport.message.statusSuccess",
            statusFailed: "admin.cartonGradesImport.message.statusFailed"
        },
        column: {
            importDate: "admin.cartonGradesImport.column.importDate",
            importDuration: "admin.cartonGradesImport.column.importDuration",
            importUser: "admin.cartonGradesImport.column.importUser",
            totalGrades: "admin.cartonGradesImport.column.totalGrades",
            updatedGrades: "admin.cartonGradesImport.column.updatedGrades",
            newGrades: "admin.cartonGradesImport.column.newGrades",
            removedGrades: "admin.cartonGradesImport.column.removedGrades",
            totalPlants: "admin.cartonGradesImport.column.totalPlants",
            knownPlants: "admin.cartonGradesImport.column.knownPlants",
            newPlants: "admin.cartonGradesImport.column.newPlants",
            removedPlants: "admin.cartonGradesImport.column.removedPlants",
            updatedGradesValueChanges: "admin.cartonGradesImport.column.updatedGradesValueChanges",
            newGradesSinceLastImport: "admin.cartonGradesImport.column.newGradesSinceLastImport",
            removedGradesSinceLastImport: "admin.cartonGradesImport.column.removedGradesSinceLastImport",
            knownPlantsWithImportedGrades: "admin.cartonGradesImport.column.knownPlantsWithImportedGrades",
            newPlantsWithImportedGrades: "admin.cartonGradesImport.column.newPlantsWithImportedGrades",
            removedPlantsWithoutGrades: "admin.cartonGradesImport.column.removedPlantsWithoutGrades"
        }
    },
    languageFiles: {
        page: {
            title: "admin.languageFiles.page.title",
            cardTitle: "admin.languageFiles.page.cardTitle",
            protocolCardTitle: "admin.languageFiles.page.protocolCardTitle"
        },
        column: {
            language: "admin.languageFiles.column.language",
            maintained: "admin.languageFiles.column.maintained",
            entryCount: "admin.languageFiles.column.entryCount",
            deviating: "admin.languageFiles.column.deviating",
            lastContentChange: "admin.languageFiles.column.lastContentChange",
            serverVersion: "admin.languageFiles.column.serverVersion",
            lastImportDate: "admin.languageFiles.column.lastImportDate",
            lastImportUser: "admin.languageFiles.column.lastImportUser",
            lastImportStatus: "admin.languageFiles.column.lastImportStatus"
        },
        protocolColumn: {
            date: "admin.languageFiles.protocolColumn.date"
        },
        message: {
            maintained: "admin.languageFiles.message.maintained",
            notMaintained: "admin.languageFiles.message.notMaintained",
            importSuccess: "admin.languageFiles.message.importSuccess",
            importFailed: "admin.languageFiles.message.importFailed",
            noImportYet: "admin.languageFiles.message.noImportYet",
            loadFailed: "admin.languageFiles.message.loadFailed",
            downloadFailed: "admin.languageFiles.message.downloadFailed",
            uploadFailed: "admin.languageFiles.message.uploadFailed",
            noImportLogsFound: "admin.languageFiles.message.noImportLogsFound",
            importLogListLoadFailed: "admin.languageFiles.message.importLogListLoadFailed",
            importLogDetailLoadFailed: "admin.languageFiles.message.importLogDetailLoadFailed"
        },
        action: {
            download: "admin.languageFiles.action.download",
            upload: "admin.languageFiles.action.upload"
        },
        dialog: {
            confirmTitle: "admin.languageFiles.dialog.confirmTitle",
            confirmMessage: "admin.languageFiles.dialog.confirmMessage",
            importLogTitle: "admin.languageFiles.dialog.importLogTitle",
            infoTitle: "admin.languageFiles.dialog.infoTitle",
            findingsTitle: "admin.languageFiles.dialog.findingsTitle",
            warningCount: "admin.languageFiles.dialog.warningCount",
            overallStatusTitle: "admin.languageFiles.dialog.overallStatusTitle"
        },
        finding: {
            rowNumber: "admin.languageFiles.finding.rowNumber",
            key: "admin.languageFiles.finding.key",
            message: "admin.languageFiles.finding.message",
            severity: "admin.languageFiles.finding.severity",
            noFindings: "admin.languageFiles.finding.noFindings"
        },
        severity: {
            ERROR: "admin.languageFiles.severity.ERROR",
            WARNING: "admin.languageFiles.severity.WARNING"
        }
    },
    addressAdmin: {
        page: {
            title: "admin.addressAdmin.page.title"
        },
        column: {
            street: "admin.addressAdmin.column.street",
            houseNumber: "admin.addressAdmin.column.houseNumber",
            zip: "admin.addressAdmin.column.zip",
            city: "admin.addressAdmin.column.city",
            country: "admin.addressAdmin.column.country",
            latitude: "admin.addressAdmin.column.latitude",
            longitude: "admin.addressAdmin.column.longitude",
            calculationStatus: "admin.addressAdmin.column.calculationStatus",
            company: "admin.addressAdmin.column.company",
            requestNumber: "admin.addressAdmin.column.requestNumber"
        },
        dialog: {
            editTitle: "admin.addressAdmin.dialog.editTitle"
        },
        validation: {
            latitudeRequired: "admin.addressAdmin.validation.latitudeRequired",
            longitudeRequired: "admin.addressAdmin.validation.longitudeRequired"
        },
        message: {
            loadFailed: "admin.addressAdmin.message.loadFailed",
            notFound: "admin.addressAdmin.message.notFound"
        }
    },
    generateCompanySignupLink: {
        action: {
            generate: "admin.generateCompanySignupLink.action.generate"
        },
        dialog: {
            confirmTitle: "admin.generateCompanySignupLink.dialog.confirmTitle",
            confirmMessage: "admin.generateCompanySignupLink.dialog.confirmMessage"
        },
        message: {
            errorConflict: "admin.generateCompanySignupLink.message.errorConflict",
            errorNotFound: "admin.generateCompanySignupLink.message.errorNotFound"
        }
    },
    generateUserSignupLink: {
        action: {
            generate: "admin.generateUserSignupLink.action.generate"
        },
        dialog: {
            confirmTitle: "admin.generateUserSignupLink.dialog.confirmTitle",
            confirmMessage: "admin.generateUserSignupLink.dialog.confirmMessage"
        },
        message: {
            errorConflict: "admin.generateUserSignupLink.message.errorConflict",
            errorNotFound: "admin.generateUserSignupLink.message.errorNotFound"
        }
    },
    generatePasswordResetLink: {
        action: {
            generate: "admin.generatePasswordResetLink.action.generate"
        },
        dialog: {
            confirmTitle: "admin.generatePasswordResetLink.dialog.confirmTitle",
            confirmMessage: "admin.generatePasswordResetLink.dialog.confirmMessage"
        },
        message: {
            errorConflict: "admin.generatePasswordResetLink.message.errorConflict",
            errorNotFound: "admin.generatePasswordResetLink.message.errorNotFound"
        }
    },
    control: {
        page: {
            title: "admin.control.page.title",
            timeControlTitle: "admin.control.page.timeControlTitle",
            jobControlTitle: "admin.control.page.jobControlTitle"
        },
        field: {
            referenceDate: "admin.control.field.referenceDate",
            systemDate: "admin.control.field.systemDate"
        },
        action: {
            setDate: "admin.control.action.setDate",
            requestWatch: "admin.control.action.requestWatch",
            mailSend: "admin.control.action.mailSend",
            companyWatch: "admin.control.action.companyWatch",
            documentRetention: "admin.control.action.documentRetention",
            orderWatch: "admin.control.action.orderWatch",
            distanceCalculation: "admin.control.action.distanceCalculation",
            geocoding: "admin.control.action.geocoding"
        },
        message: {
            loadTimeControlFailed: "admin.control.message.loadTimeControlFailed",
            setDateFailed: "admin.control.message.setDateFailed",
            requestWatchSuccess: "admin.control.message.requestWatchSuccess",
            requestWatchFailed: "admin.control.message.requestWatchFailed",
            mailSendSuccess: "admin.control.message.mailSendSuccess",
            mailSendFailed: "admin.control.message.mailSendFailed",
            companyWatchSuccess: "admin.control.message.companyWatchSuccess",
            companyWatchFailed: "admin.control.message.companyWatchFailed",
            documentRetentionSuccess: "admin.control.message.documentRetentionSuccess",
            documentRetentionFailed: "admin.control.message.documentRetentionFailed",
            orderWatchSuccess: "admin.control.message.orderWatchSuccess",
            orderWatchFailed: "admin.control.message.orderWatchFailed",
            distanceCalculationSuccess: "admin.control.message.distanceCalculationSuccess",
            distanceCalculationFailed: "admin.control.message.distanceCalculationFailed",
            geocodingSuccess: "admin.control.message.geocodingSuccess",
            geocodingFailed: "admin.control.message.geocodingFailed"
        }
    }
};

export const ReportI18N = {
  page: {
    title: "report.page.title",
    tab: {
      aggregate: "report.page.tab.aggregate",
      detail: "report.page.tab.detail",
      collaboration: "report.page.tab.collaboration"
    },
    filter: {
      from: "report.page.filter.from",
      to: "report.page.filter.to",
      error: "report.page.filter.error"
    },
    action: {
      export: "report.page.action.export"
    },
    report: {
      requestsByCompany: "report.page.report.requestsByCompany",
      quotesByCompany: "report.page.report.quotesByCompany",
      requestsByMonth: "report.page.report.requestsByMonth",
      quotesByMonth: "report.page.report.quotesByMonth",
      requestStatusByCompany: "report.page.report.requestStatusByCompany",
      quoteStatusByCompany: "report.page.report.quoteStatusByCompany",
      collaborationSummary: "report.page.report.collaborationSummary",
      collaborationByMonth: "report.page.report.collaborationByMonth",
      requestsDetail: "report.page.report.requestsDetail",
      quotesDetail: "report.page.report.quotesDetail",
      supplierRequester: "report.page.report.supplierRequester"
    },
    column: {
      company: "report.page.column.company",
      companyNumber: "report.page.column.companyNumber",
      count: "report.page.column.count",
      month: "report.page.column.month",
      year: "report.page.column.year",
      status: "report.page.column.status",
      publishedAt: "report.page.column.publishedAt",
      statusDate: "report.page.column.statusDate",
      referenceNumber: "report.page.column.referenceNumber",
      requestReferenceNumber: "report.page.column.requestReferenceNumber",
      quoteReferenceNumber: "report.page.column.quoteReferenceNumber",
      requester: "report.page.column.requester",
      supplier: "report.page.column.supplier",
      quoteStatus: "report.page.column.quoteStatus"
    }
  }
};

export const CompanyI18N = {
    form: {
        page: {
            addressEditTitle: "company.form.page.addressEditTitle",
            title: "company.form.page.title",
            moreDataTitle: "company.form.page.moreDataTitle",
            moreDataCompanyTitle: "company.form.page.moreDataCompanyTitle",
            erpDataTitle: "company.form.page.erpDataTitle",
            bankConnectionTitle: "company.form.page.bankConnectionTitle",
            erpSystemTitle: "company.form.page.erpSystemTitle",
            inviteTitle: "company.form.page.inviteTitle"
        },
        field: {
            deliveryInstructionsTitle: "company.form.field.deliveryInstructionsTitle",
            name: "company.form.field.name",
            country: "company.form.field.country",
            legalForm: "company.form.field.legalForm",
            legalFormCountryHint: "company.form.field.legalFormCountryHint",
            website: "company.form.field.website",
            commercialRegisterNumber: "company.form.field.commercialRegisterNumber",
            vatId: "company.form.field.vatId",
            street: "company.form.field.street",
            houseNumber: "company.form.field.houseNumber",
            postalCode: "company.form.field.postalCode",
            city: "company.form.field.city",
            isHeadquarter: "company.form.field.isHeadquarter",
            headquarter: "company.form.field.headquarter",
            isTimeSlotBooking: "company.form.field.isTimeSlotBooking",
            preAdviceNote: "company.form.field.preAdviceNote",
            officeHours: "company.form.field.officeHours",
            erpManufacturer: "company.form.field.erpManufacturer",
            erpSoftwareName: "company.form.field.erpSoftwareName",
            erpSoftwareVersion: "company.form.field.erpSoftwareVersion",
            machineryPark: "company.form.field.machineryPark",
            miniliner: "company.form.field.miniliner",
            midliner: "company.form.field.midliner",
            maxiliner: "company.form.field.maxiliner",
            dieCutting: "company.form.field.dieCutting",
            folderGluerMachine: "company.form.field.folderGluerMachine",
            packaging: "company.form.field.packaging",
            hazardousGoodsQualification: "company.form.field.hazardousGoodsQualification",
            flexoPrinting: "company.form.field.flexoPrinting",
            hdFlexoPrinting: "company.form.field.hdFlexoPrinting",
            offsetPrinting: "company.form.field.offsetPrinting",
            digitalPrinting: "company.form.field.digitalPrinting",
            additionalInformation: "company.form.field.additionalInformation",
            bankName: "company.form.field.bankName",
            iban: "company.form.field.iban",
            bic: "company.form.field.bic",
            paymentTerms: "company.form.field.paymentTerms",
            monday: "company.form.field.monday",
            tuesday: "company.form.field.tuesday",
            wednesday: "company.form.field.wednesday",
            thursday: "company.form.field.thursday",
            friday: "company.form.field.friday",
            saturday: "company.form.field.saturday",
            sunday: "company.form.field.sunday",
            mondayShort: "company.form.field.mondayShort",
            tuesdayShort: "company.form.field.tuesdayShort",
            wednesdayShort: "company.form.field.wednesdayShort",
            thursdayShort: "company.form.field.thursdayShort",
            fridayShort: "company.form.field.fridayShort",
            saturdayShort: "company.form.field.saturdayShort",
            sundayShort: "company.form.field.sundayShort",
            timeSlotBookingYes: "company.form.field.timeSlotBookingYes",
            timeSlotBookingNo: "company.form.field.timeSlotBookingNo"
        },
        legend: {
            title: "company.form.legend.title",
            machineryParkAvailable: "company.form.legend.machineryParkAvailable",
            machineryParkNotAvailable: "company.form.legend.machineryParkNotAvailable"
        },
        validation: {
            nameMin: "company.form.validation.nameMin",
            nameMax: "company.form.validation.nameMax",
            nameRequired: "company.form.validation.nameRequired",
            countryRequired: "company.form.validation.countryRequired",
            countryInvalid: "company.form.validation.countryInvalid",
            legalFormRequired: "company.form.validation.legalFormRequired",
            legalFormInvalid: "company.form.validation.legalFormInvalid",
            legalFormForCountryInvalid: "company.form.validation.legalFormForCountryInvalid",
            websiteMin: "company.form.validation.websiteMin",
            websiteMax: "company.form.validation.websiteMax",
            websiteInvalid: "company.form.validation.websiteInvalid",
            commercialRegisterNumberRequired: "company.form.validation.commercialRegisterNumberRequired",
            commercialRegisterNumberMin: "company.form.validation.commercialRegisterNumberMin",
            commercialRegisterNumberMax: "company.form.validation.commercialRegisterNumberMax",
            commercialRegisterNumberInvalid: "company.form.validation.commercialRegisterNumberInvalid",
            vatIdMin: "company.form.validation.vatIdMin",
            vatIdMax: "company.form.validation.vatIdMax",
            vatIdInvalid: "company.form.validation.vatIdInvalid",
            streetRequired: "company.form.validation.streetRequired",
            streetMin: "company.form.validation.streetMin",
            streetMax: "company.form.validation.streetMax",
            houseNumberRequired: "company.form.validation.houseNumberRequired",
            houseNumberMin: "company.form.validation.houseNumberMin",
            houseNumberMax: "company.form.validation.houseNumberMax",
            postalCodeRequired: "company.form.validation.postalCodeRequired",
            postalCodeMin: "company.form.validation.postalCodeMin",
            postalCodeMax: "company.form.validation.postalCodeMax",
            postalCodeInvalid: "company.form.validation.postalCodeInvalid",
            cityRequired: "company.form.validation.cityRequired",
            cityMin: "company.form.validation.cityMin",
            cityMax: "company.form.validation.cityMax",
            officeHoursRequired: "company.form.validation.officeHoursRequired",
            officeHoursMin: "company.form.validation.officeHoursMin",
            officeHoursMax: "company.form.validation.officeHoursMax",
            erpManufacturerRequired: "company.form.validation.erpManufacturerRequired",
            erpManufacturerMin: "company.form.validation.erpManufacturerMin",
            erpManufacturerMax: "company.form.validation.erpManufacturerMax",
            erpSoftwareNameRequired: "company.form.validation.erpSoftwareNameRequired",
            erpSoftwareNameMin: "company.form.validation.erpSoftwareNameMin",
            erpSoftwareNameMax: "company.form.validation.erpSoftwareNameMax",
            erpSoftwareVersionRequired: "company.form.validation.erpSoftwareVersionRequired",
            erpSoftwareVersionMin: "company.form.validation.erpSoftwareVersionMin",
            erpSoftwareVersionMax: "company.form.validation.erpSoftwareVersionMax",
            additionalInformationMax: "company.form.validation.additionalInformationMax",
            bankNameRequired: "company.form.validation.bankNameRequired",
            bankNameMin: "company.form.validation.bankNameMin",
            bankNameMax: "company.form.validation.bankNameMax",
            ibanRequired: "company.form.validation.ibanRequired",
            ibanMin: "company.form.validation.ibanMin",
            ibanMax: "company.form.validation.ibanMax",
            ibanInvalid: "company.form.validation.ibanInvalid",
            bicRequired: "company.form.validation.bicRequired",
            bicMin: "company.form.validation.bicMin",
            bicMax: "company.form.validation.bicMax",
            bicInvalid: "company.form.validation.bicInvalid",
            paymentTermsRequired: "company.form.validation.paymentTermsRequired",
            paymentTermsMin: "company.form.validation.paymentTermsMin",
            paymentTermsMax: "company.form.validation.paymentTermsMax",
            deliveryInstructionsMax: "company.form.validation.deliveryInstructionsMax",
            arrivalNotificationMax: "company.form.validation.arrivalNotificationMax"
        },
        tooltip: {
            deliveryInstructionsEmpty: "company.form.tooltip.deliveryInstructionsEmpty",
            deliveryInstructionsEmptyValue: "company.form.tooltip.deliveryInstructionsEmptyValue"
        },
        action: {
            save: "company.form.action.save"
        },
        dialog: {
            lockTitle: "company.form.dialog.lockTitle",
            lockMessage: "company.form.dialog.lockMessage",
            legalFormForCountryTitle: "company.form.dialog.legalFormForCountryTitle",
            legalFormForCountryMessage: "company.form.dialog.legalFormForCountryMessage"
        },
        message: {
            loadStatisticsFailed: "company.form.message.loadStatisticsFailed"
        }
    },
    termination: {
        dialog: {
            title: "company.termination.dialog.title",
            confirmTitle: "company.termination.dialog.confirmTitle",
            confirmMessage: "company.termination.dialog.confirmMessage",
            revertConfirmTitle: "company.termination.dialog.revertConfirmTitle",
            revertConfirmMessage: "company.termination.dialog.revertConfirmMessage"
        },
        page: {
            cardTitle: "company.termination.page.cardTitle"
        },
        field: {
            status: "company.termination.field.status",
            date: "company.termination.field.date",
            reason: "company.termination.field.reason",
            initiator: "company.termination.field.initiator",
            requestedAt: "company.termination.field.requestedAt",
            requestedBy: "company.termination.field.requestedBy"
        },
        action: {
            terminate: "company.termination.action.terminate",
            revert: "company.termination.action.revert"
        },
        validation: {
            dateRequired: "company.termination.validation.dateRequired",
            dateInvalid: "company.termination.validation.dateInvalid",
            initiatorRequired: "company.termination.validation.initiatorRequired",
            initiatorInvalid: "company.termination.validation.initiatorInvalid",
            reasonRequired: "company.termination.validation.reasonRequired",
            reasonMin: "company.termination.validation.reasonMin",
            reasonMax: "company.termination.validation.reasonMax"
        },
        message: {
            revertFailed: "company.termination.message.revertFailed",
            revertSuccess: "company.termination.message.revertSuccess"
        }
    },
    blocking: {
        page: {
            cardTitle: "company.blocking.page.cardTitle"
        },
        field: {
            status: "company.blocking.field.status",
            reason: "company.blocking.field.reason",
            requestedAt: "company.blocking.field.requestedAt",
            requestedBy: "company.blocking.field.requestedBy",
            locked: "company.blocking.field.locked",
            sumOpenRequests: "company.blocking.field.sumOpenRequests",
            sumSentQuotes: "company.blocking.field.sumSentQuotes"
        },
        dialog: {
            title: "company.blocking.dialog.title",
            confirmTitle: "company.blocking.dialog.confirmTitle",
            confirmMessage: "company.blocking.dialog.confirmMessage",
            revertConfirmTitle: "company.blocking.dialog.revertConfirmTitle",
            revertConfirmMessage: "company.blocking.dialog.revertConfirmMessage"
        },
        validation: {
            reasonMax: "company.blocking.validation.reasonMax"
        },
        action: {
            block: "company.blocking.action.block",
            unblock: "company.blocking.action.unblock"
        },
        message: {
            revertFailed: "company.blocking.message.revertFailed",
            revertSuccess: "company.blocking.message.revertSuccess"
        }
    },
    reactivation: {
        action: {
            reactivate: "company.reactivation.action.reactivate"
        },
        message: {
            success: "company.reactivation.message.success",
            failed: "company.reactivation.message.failed"
        },
        dialog: {
            confirmTitle: "company.reactivation.dialog.confirmTitle",
            confirmMessage: "company.reactivation.dialog.confirmMessage"
        }
    }
};

export const InvitationI18N = {
  invitationCardTitle: "Invitation.invitationCardTitle",
  invitedAtLabel: "Invitation.invitedAtLabel",
  lastInvitationAtLabel: "Invitation.lastInvitationAtLabel",
  validUntilLabel: "Invitation.validUntilLabel",
  expiredHint: "Invitation.expiredHint"
};

export const UserI18N = {
  notifications: {
    page: {
      title: "user.notifications.page.title"
    },
    section: {
      requester: "user.notifications.section.requester",
      offerer: "user.notifications.section.offerer"
    },
    subgroup: {
      eventBased: "user.notifications.subgroup.eventBased",
      automatic: "user.notifications.subgroup.automatic"
    },
    label: {
      requestPublishedMe: "user.notifications.label.requestPublishedMe",
      requestPublishedColleagues: "user.notifications.label.requestPublishedColleagues",
      requestCancelledMe: "user.notifications.label.requestCancelledMe",
      requestCancelledColleagues: "user.notifications.label.requestCancelledColleagues",
      requestDeactivatedAfterDue: "user.notifications.label.requestDeactivatedAfterDue",
      newRequestAvailable: "user.notifications.label.newRequestAvailable",
      offerReceived: "user.notifications.label.offerReceived",
      offerConfirmedMe: "user.notifications.label.offerConfirmedMe",
      offerConfirmedColleagues: "user.notifications.label.offerConfirmedColleagues",
      incomingCoopRequestConfirmedMe: "user.notifications.label.incomingCoopRequestConfirmedMe",
      incomingCoopRequestConfirmedColleagues: "user.notifications.label.incomingCoopRequestConfirmedColleagues",
      yourCoopOfferAccepted: "user.notifications.label.yourCoopOfferAccepted",
      yourCoopOfferDeclined: "user.notifications.label.yourCoopOfferDeclined",
      requestReminderBeforeDue: "user.notifications.label.requestReminderBeforeDue",
      offerDeactivatedAfterDue: "user.notifications.label.offerDeactivatedAfterDue",
      quoteFeedbackReceived: "user.notifications.label.quoteFeedbackReceived",
      revisedQuoteReceived: "user.notifications.label.revisedQuoteReceived",
      requestDatesExtended: "user.notifications.label.requestDatesExtended",
      requestAdditionalInformationUpdated: "user.notifications.label.requestAdditionalInformationUpdated",
      quoteWithdrawn: "user.notifications.label.quoteWithdrawn",
      requestCancelledSupplier: "user.notifications.label.requestCancelledSupplier",
      orderStatusChangedRequester: "user.notifications.label.orderStatusChangedRequester",
      orderStatusChangedOfferer: "user.notifications.label.orderStatusChangedOfferer"
    },
    field: {
      maxDistanceKm: "user.notifications.field.maxDistanceKm"
    },
    tooltip: {
      maxDistanceKmHelp: "user.notifications.tooltip.maxDistanceKmHelp"
    },
    validation: {
      maxDistanceKmInvalid: "user.notifications.validation.maxDistanceKmInvalid"
    },
    action: {
      saveCurrentCompany: "user.notifications.action.saveCurrentCompany",
      saveAllCompanies: "user.notifications.action.saveAllCompanies"
    },
    dialog: {
      copyTitle: "user.notifications.dialog.copyTitle",
      copyContent: "user.notifications.dialog.copyContent",
      copyWarning: "user.notifications.dialog.copyWarning"
    },
    message: {
      copySuccess: "user.notifications.message.copySuccess",
      copyCombinedSuccess: "user.notifications.message.copyCombinedSuccess"
    }
  },
  form: {
    page: {
      title: "user.form.page.title",
      inviteTitle: "user.form.page.inviteTitle",
      insertEmailTitle: "user.form.page.insertEmailTitle",
      resetPasswordTitle: "user.form.page.resetPasswordTitle", // NOSONAR
      resetPasswordSubtitle: "user.form.page.resetPasswordSubtitle" // NOSONAR
    },
    field: {
      email: "user.form.field.email",
      password: "user.form.field.password", // NOSONAR
      confirmPassword: "user.form.field.confirmPassword", // NOSONAR
      resetPassword: "user.form.field.resetPassword", // NOSONAR
      salutation: "user.form.field.salutation",
      firstName: "user.form.field.firstName",
      lastName: "user.form.field.lastName",
      phone: "user.form.field.phone",
      fax: "user.form.field.fax",
      language: "user.form.field.language",
      isCEO: "user.form.field.isCEO",
      profile: "user.form.field.profile",
      apiToken: "user.form.field.apiToken",
      apiTokenExpirationDate: "user.form.field.apiTokenExpirationDate",
      companyId: "user.form.field.companyId",
      currentPassword: "user.form.field.currentPassword", // NOSONAR
      newPassword: "user.form.field.newPassword" // NOSONAR
    },
    action: {
      requestResetPassword: "user.form.action.requestResetPassword", // NOSONAR
      inviteEmployee: "user.form.action.inviteEmployee",
      generateNewApiToken: "user.form.action.generateNewApiToken"
    },
    validation: {
      emailRequired: "user.form.validation.emailRequired",
      emailMin: "user.form.validation.emailMin",
      emailMax: "user.form.validation.emailMax",
      emailInvalid: "user.form.validation.emailInvalid",
      passwordRequired: "user.form.validation.passwordRequired", // NOSONAR
      passwordMin: "user.form.validation.passwordMin", // NOSONAR
      passwordMax: "user.form.validation.passwordMax", // NOSONAR
      passwordInvalid: "user.form.validation.passwordInvalid", // NOSONAR
      passwordsMustMatch: "user.form.validation.passwordsMustMatch", // NOSONAR
      salutationRequired: "user.form.validation.salutationRequired",
      salutationInvalid: "user.form.validation.salutationInvalid",
      firstNameRequired: "user.form.validation.firstNameRequired",
      firstNameMin: "user.form.validation.firstNameMin",
      firstNameMax: "user.form.validation.firstNameMax",
      lastNameRequired: "user.form.validation.lastNameRequired",
      lastNameMin: "user.form.validation.lastNameMin",
      lastNameMax: "user.form.validation.lastNameMax",
      phoneRequired: "user.form.validation.phoneRequired",
      phoneMin: "user.form.validation.phoneMin",
      phoneMax: "user.form.validation.phoneMax",
      phoneInvalid: "user.form.validation.phoneInvalid",
      faxMin: "user.form.validation.faxMin",
      faxMax: "user.form.validation.faxMax",
      faxInvalid: "user.form.validation.faxInvalid",
      languageRequired: "user.form.validation.languageRequired",
      isCEORequired: "user.form.validation.isCEORequired",
      mustBeCEO: "user.form.validation.mustBeCEO"
    },
    tooltip: {
      emailCannotBeChanged: "user.form.tooltip.emailCannotBeChanged"
    },
    message: {
      emailCannotBeChanged: "user.form.message.emailCannotBeChanged",
      requestPasswordResetSuccessTitle: "user.form.message.requestPasswordResetSuccessTitle", // NOSONAR
      requestPasswordResetSuccessSubtitle: "user.form.message.requestPasswordResetSuccessSubtitle", // NOSONAR
      requestPasswordResetFailedTitle: "user.form.message.requestPasswordResetFailedTitle", // NOSONAR
      requestPasswordResetFailedSubtitle: "user.form.message.requestPasswordResetFailedSubtitle", // NOSONAR
      passwordResetSuccessTitle: "user.form.message.passwordResetSuccessTitle", // NOSONAR
      passwordResetSuccessSubtitle: "user.form.message.passwordResetSuccessSubtitle", // NOSONAR
      passwordResetFailedTitle: "user.form.message.passwordResetFailedTitle", // NOSONAR
      passwordResetFailedSubtitle: "user.form.message.passwordResetFailedSubtitle", // NOSONAR
      generatedApiTokenFailed: "user.form.message.generatedApiTokenFailed",
      noApiToken: "user.form.message.noApiToken",
      changePasswordSuccess: "user.form.message.changePasswordSuccess" // NOSONAR
    },
    dialog: {
      generatedApiTokenTitle: "user.form.dialog.generatedApiTokenTitle",
      generatedApiTokenMessage: "user.form.dialog.generatedApiTokenMessage",
      newApiTokenTitle: "user.form.dialog.newApiTokenTitle",
      lockTitle: "user.form.dialog.lockTitle",
      lockMessage: "user.form.dialog.lockMessage"
    }
  }
};

export const RequestI18N = {
    details: {
        page: {
            title: "request.details.page.title",
            fromCompanyTitle: "request.details.page.fromCompanyTitle",
            cancellationReasonCardTitle: "request.details.page.cancellationReasonCardTitle",
            closureHelpCardTitle: "request.details.page.closureHelpCardTitle",
            internalConfirmationCardTitle: "request.details.page.internalConfirmationCardTitle",
            quoteTitle: "request.details.page.quoteTitle",
            quoteFromCompanyTitle: "request.details.page.quoteFromCompanyTitle",
            palletizingCardTitle: "request.details.page.palletizingCardTitle",
            pricingCardTitle: "request.details.page.pricingCardTitle"
        },
        field: {
            customerRequestNumber: "request.details.field.customerRequestNumber",
            customerQuoteNumber: "request.details.field.customerQuoteNumber",
            quoteInformation: "request.details.field.quoteInformation",
            deliveryDateRange: "request.details.field.deliveryDateRange",
            deliveryDate: "request.details.field.deliveryDate",
            deliveryAddress: "request.details.field.deliveryAddress",
            deviatingDeliveryAddress: "request.details.field.deviatingDeliveryAddress",
            hideDeliveryAddress: "request.details.field.hideDeliveryAddress",
            rfi: "request.details.field.rfi",
            rfiOrderRequest: "request.details.field.rfiOrderRequest",
            rfiTenderRequest: "request.details.field.rfiTenderRequest",
            companyAddress: "request.details.field.companyAddress",
            variety: "request.details.field.variety",
            fefcoCode: "request.details.field.fefcoCode",
            palletType: "request.details.field.palletType",
            internalDimensions: "request.details.field.internalDimensions",
            externalPrint: "request.details.field.externalPrint",
            internalPrint: "request.details.field.internalPrint",
            dangerousGoods: "request.details.field.dangerousGoods",
            contractGluing: "request.details.field.contractGluing",
            numberOfColors: "request.details.field.numberOfColors",
            numberOfPallet: "request.details.field.numberOfPallet",
            palletLabelNeutral: "request.details.field.palletLabelNeutral",
            pcsShort: "request.details.field.pcsShort",
            stretching: "request.details.field.stretching",
            closureType: "request.details.field.closureType",
            palletizingFixed: "request.details.field.palletizingFixed",
            glue: "request.details.field.glue",
            staple: "request.details.field.staple",
            tap: "request.details.field.tap",
            siliconTape: "request.details.field.siliconTape",
            tearTape: "request.details.field.tearTape",
            counterPallets: "request.details.field.counterPallets",
            palletExchange: "request.details.field.palletExchange",
            allowPalletOverhang: "request.details.field.allowPalletOverhang",
            palletOverhang: "request.details.field.palletOverhang",
            quantity: "request.details.field.quantity",
            totalPriceShort: "request.details.field.totalPriceShort",
            palletHeight: "request.details.field.palletHeight",
            seriesOrder: "request.details.field.seriesOrder",
            seriesSingleOrder: "request.details.field.seriesSingleOrder",
            seriesSeriesOrder: "request.details.field.seriesSeriesOrder",
            seriesTotalQuantity: "request.details.field.seriesTotalQuantity",
            netPrice: "request.details.field.netPrice",
            netPriceShort: "request.details.field.netPriceShort",
            separateExtraCosts: "request.details.field.separateExtraCosts",
            toolingCosts: "request.details.field.toolingCosts",
            clicheCosts: "request.details.field.clicheCosts",
            contactPerson: "request.details.field.contactPerson",
            phoneNumber: "request.details.field.phoneNumber",
            telefax: "request.details.field.telefax",
            paymentTerms: "request.details.field.paymentTerms",
            additionalInformation: "request.details.field.additionalInformation",
            documentsAndAdditionalInformation: "request.details.field.documentsAndAdditionalInformation",
            status: "request.details.field.status",
            deliveryDateFrom: "request.details.field.deliveryDateFrom",
            deliveryDateTo: "request.details.field.deliveryDateTo",
            length: "request.details.field.length",
            height: "request.details.field.height",
            width: "request.details.field.width",
            netPriceFreeOfHouse: "request.details.field.netPriceFreeOfHouse",
            cancellationReason: "request.details.field.cancellationReason",
            cancellationReasonPlaceholder: "request.details.field.cancellationReasonPlaceholder",
            withdrawalReason: "request.details.field.withdrawalReason",
            withdrawalReasonPlaceholder: "request.details.field.withdrawalReasonPlaceholder",
            quoteValidity: "request.details.field.quoteValidity",
            requestValidity: "request.details.field.requestValidity",
            printImages: "request.details.field.printImages",
            constructionDrawings: "request.details.field.constructionDrawings",
            info: "request.details.field.info",
            hasPrintImages: "request.details.field.hasPrintImages",
            proGroupCartonGrade: "request.details.field.proGroupCartonGrade",
            hasBlueprints: "request.details.field.hasBlueprints",
            pricePerPallet: "request.details.field.pricePerPallet",
            quantityPerPallet: "request.details.field.quantityPerPallet",
            bundlesPerPackage: "request.details.field.bundlesPerPackage",
            rejectQuoteReason: "request.details.field.rejectQuoteReason",
            feedback: "request.details.field.feedback",
            receivedFeedback: "request.details.field.receivedFeedback",
            quoteVersionSuffix: "request.details.field.quoteVersionSuffix",
            distanceToRequester: "request.details.field.distanceToRequester",
            directionToRequester: "request.details.field.directionToRequester",
            requesterCompany: "request.details.field.requesterCompany",
            deliveryDistancePending: "request.details.field.deliveryDistancePending",
            deliveryDistanceError: "request.details.field.deliveryDistanceError",
            remainingValidityDays: "request.details.field.remainingValidityDays",
            remainingValidityTomorrow: "request.details.field.remainingValidityTomorrow",
            remainingValidityToday: "request.details.field.remainingValidityToday",
            additionalInformationBuyer: "request.details.field.additionalInformationBuyer",
            additionalInformationSupplier: "request.details.field.additionalInformationSupplier",
            confirmInternallyReason: "request.details.field.confirmInternallyReason",
            internalConfirmationReason: "request.details.field.internalConfirmationReason",
            internalConfirmationDate: "request.details.field.internalConfirmationDate",
            internalConfirmationBy: "request.details.field.internalConfirmationBy"
        },
        message: {
            hiddenDeliveryAddressHint: "request.details.message.hiddenDeliveryAddressHint",
            varietyLoading: "request.details.message.varietyLoading",
            deleteSuccess: "request.details.message.deleteSuccess",
            deleteFailed: "request.details.message.deleteFailed",
            model: "request.details.message.model",
            publishSuccessTitle: "request.details.message.publishSuccessTitle",
            publishSuccessConfirm: "request.details.message.publishSuccessConfirm",
            clipboardCopied: "request.details.message.clipboardCopied",
            clipboardFailed: "request.details.message.clipboardFailed",
            clipboardNotSupported: "request.details.message.clipboardNotSupported",
            quoteConfirmed: "request.details.message.quoteConfirmed",
            quoteDismissed: "request.details.message.quoteDismissed",
            cancelConfirmedNotification: "request.details.message.cancelConfirmedNotification",
            selectQuoteError: "request.details.message.selectQuoteError",
            withdrawQuoteSuccess: "request.details.message.withdrawQuoteSuccess",
            withdrawConfirmed: "request.details.message.withdrawConfirmed",
            cancellationReasonInfo: "request.details.message.cancellationReasonInfo",
            noCancellationReason: "request.details.message.noCancellationReason",
            extendDatesSuccess: "request.details.message.extendDatesSuccess",
            unsavedChanges: "request.details.message.unsavedChanges",
            requestSavedSuccess: "request.details.message.requestSavedSuccess",
            quoteSubmittedSuccess: "request.details.message.quoteSubmittedSuccess",
            requestRejectedSuccess: "request.details.message.requestRejectedSuccess",
            requestRevokeSuccess: "request.details.message.requestRevokeSuccess",
            noRejectReason: "request.details.message.noRejectReason",
            giveFeedbackSuccess: "request.details.message.giveFeedbackSuccess",
            submitRevisedBidSuccess: "request.details.message.submitRevisedBidSuccess",
            quoteWithdrawnAfterSubmission: "request.details.message.quoteWithdrawnAfterSubmission",
            editAdditionalInformationSuccess: "request.details.message.editAdditionalInformationSuccess",
            editAdditionalInformationEmailHint: "request.details.message.editAdditionalInformationEmailHint",
            resendPublishNotificationSuccess: "request.details.message.resendPublishNotificationSuccess",
            confirmInternallySuccess: "request.details.message.confirmInternallySuccess"
        },
        action: {
            publish: "request.details.action.publish",
            delete: "request.details.action.delete",
            edit: "request.details.action.edit",
            copy: "request.details.action.copy",
            confirm: "request.details.action.confirm",
            sendQuote: "request.details.action.sendQuote",
            unpublishSave: "request.details.action.unpublishSave",
            stay: "request.details.action.stay",
            discard: "request.details.action.discard",
            withdrawQuote: "request.details.action.withdrawQuote",
            withdraw: "request.details.action.withdraw",
            backToOverview: "request.details.action.backToOverview",
            copyRequest: "request.details.action.copyRequest",
            extendDates: "request.details.action.extendDates",
            extendDatesSave: "request.details.action.extendDatesSave",
            rejectRequest: "request.details.action.rejectRequest",
            revokeRequest: "request.details.action.revokeRequest",
            quoteOverview: "request.details.action.quoteOverview",
            giveFeedback: "request.details.action.giveFeedback",
            startRevision: "request.details.action.startRevision",
            submitRevisedBid: "request.details.action.submitRevisedBid",
            editAdditionalInformation: "request.details.action.editAdditionalInformation",
            editAdditionalInformationSave: "request.details.action.editAdditionalInformationSave",
            show: "request.details.action.show",
            resendPublishNotification: "request.details.action.resendPublishNotification",
            confirmInternally: "request.details.action.confirmInternally"
        },
        dialog: {
            confirmDeleteTitle: "request.details.dialog.confirmDeleteTitle",
            deleteMessagePartOne: "request.details.dialog.deleteMessagePartOne",
            deleteMessagePartTwo: "request.details.dialog.deleteMessagePartTwo",
            discardTitle: "request.details.dialog.discardTitle",
            submitQuoteMessage: "request.details.dialog.submitQuoteMessage",
            confirmQuoteTitle: "request.details.dialog.confirmQuoteTitle",
            confirmCancelRequestTitle: "request.details.dialog.confirmCancelRequestTitle",
            confirmCancelRequestMessage: "request.details.dialog.confirmCancelRequestMessage",
            withdrawQuoteMessage: "request.details.dialog.withdrawQuoteMessage",
            withdrawQuoteTitle: "request.details.dialog.withdrawQuoteTitle",
            withdrawRequestTitle: "request.details.dialog.withdrawRequestTitle",
            withdrawRequestMessage: "request.details.dialog.withdrawRequestMessage",
            confirmQuoteMessage: "request.details.dialog.confirmQuoteMessage",
            dismissQuoteTitle: "request.details.dialog.dismissQuoteTitle",
            rejectRequestMessage: "request.details.dialog.rejectRequestMessage",
            revokeRequestMessage: "request.details.dialog.revokeRequestMessage",
            rejectQuoteMessage: "request.details.dialog.rejectQuoteMessage",
            giveFeedbackTitle: "request.details.dialog.giveFeedbackTitle",
            giveFeedbackMessage: "request.details.dialog.giveFeedbackMessage",
            submitRevisedBidTitle: "request.details.dialog.submitRevisedBidTitle",
            submitRevisedBidMessage: "request.details.dialog.submitRevisedBidMessage",
            editAdditionalInformationTitle: "request.details.dialog.editAdditionalInformationTitle",
            resendPublishNotificationTitle: "request.details.dialog.resendPublishNotificationTitle",
            resendPublishNotificationMessage: "request.details.dialog.resendPublishNotificationMessage",
            confirmInternallyTitle: "request.details.dialog.confirmInternallyTitle",
            confirmInternallyMessage: "request.details.dialog.confirmInternallyMessage"
        },
        tooltip: {
            palletHeight: "request.details.tooltip.palletHeight",
            numberOfPallet: "request.details.tooltip.numberOfPallet",
            netPrice: "request.details.tooltip.netPrice",
            unreadMessages: "request.details.tooltip.unreadMessages",
            distanceColumn: "request.details.tooltip.distanceColumn",
            deliveryAddressHidden: "request.details.tooltip.deliveryAddressHidden"
        },
        column: {
            validUntil: "request.details.column.validUntil",
            quantity: "request.details.column.quantity",
            pricePerThousand: "request.details.column.pricePerThousand",
            total: "request.details.column.total"
        },
        label: {
            prices: "request.details.label.prices",
            companyName: "request.details.label.companyName",
            myRequest: "request.details.label.myRequest"
        },
        form: {
            product: "request.details.form.product"
        },
        recipientSelection: {
            title: "request.details.recipientSelection.title",
            optionAll: "request.details.recipientSelection.optionAll",
            optionSelected: "request.details.recipientSelection.optionSelected",
            hintAll: "request.details.recipientSelection.hintAll",
            searchLabel: "request.details.recipientSelection.searchLabel",
            selectAll: "request.details.recipientSelection.selectAll",
            deselectAll: "request.details.recipientSelection.deselectAll",
            countLabel: "request.details.recipientSelection.countLabel",
            columnCompany: "request.details.recipientSelection.columnCompany",
            columnDistance: "request.details.recipientSelection.columnDistance",
            distanceUnknown: "request.details.recipientSelection.distanceUnknown",
            distanceHint: "request.details.recipientSelection.distanceHint",
            hiddenSelectedHintOne: "request.details.recipientSelection.hiddenSelectedHintOne",
            hiddenSelectedHintMany: "request.details.recipientSelection.hiddenSelectedHintMany",
            loadFailed: "request.details.recipientSelection.loadFailed"
        },
        recipientScope: {
            title: "request.details.recipientScope.title",
            modeAll: "request.details.recipientScope.modeAll",
            modeSelected: "request.details.recipientScope.modeSelected"
        }
    },
    form: {
        validation: {
            quotationNumber: "request.form.validation.quotationNumber",
            contactPerson: "request.form.validation.contactPerson",
            company: "request.form.validation.company",
            requestNumberMaxLength: "request.form.validation.requestNumberMaxLength",
            quoteNumberMaxLength: "request.form.validation.quoteNumberMaxLength",
            deliveryDateFrom: "request.form.validation.deliveryDateFrom",
            deliveryDateTo: "request.form.validation.deliveryDateTo",
            dateFormat: "request.form.validation.dateFormat",
            variety: "request.form.validation.variety",
            fefcoCode: "request.form.validation.fefcoCode",
            fefcoCodeMax: "request.form.validation.fefcoCodeMax",
            palletType: "request.form.validation.palletType",
            lengthRequired: "request.form.validation.lengthRequired",
            lengthMin: "request.form.validation.lengthMin",
            lengthMax: "request.form.validation.lengthMax",
            widthRequired: "request.form.validation.widthRequired",
            widthMin: "request.form.validation.widthMin",
            widthMax: "request.form.validation.widthMax",
            heightRequired: "request.form.validation.heightRequired",
            heightMin: "request.form.validation.heightMin",
            heightMax: "request.form.validation.heightMax",
            printRequired: "request.form.validation.printRequired",
            numberOfColorsRequired: "request.form.validation.numberOfColorsRequired",
            numberOfColorsMin: "request.form.validation.numberOfColorsMin",
            numberOfColorsMax: "request.form.validation.numberOfColorsMax",
            palletHeightRequired: "request.form.validation.palletHeightRequired",
            palletHeightMin: "request.form.validation.palletHeightMin",
            palletHeightMax: "request.form.validation.palletHeightMax",
            palletOverhangRequired: "request.form.validation.palletOverhangRequired",
            palletOverhangMin: "request.form.validation.palletOverhangMin",
            palletOverhangMax: "request.form.validation.palletOverhangMax",
            numberOfPallet: "request.form.validation.numberOfPallet",
            quantityRequired: "request.form.validation.quantityRequired",
            quantityMin: "request.form.validation.quantityMin",
            quantityMax: "request.form.validation.quantityMax",
            integerOnly: "request.form.validation.integerOnly",
            netPriceRequired: "request.form.validation.netPriceRequired",
            netPriceMin: "request.form.validation.netPriceMin",
            netPriceMax: "request.form.validation.netPriceMax",
            toolingCostsRequired: "request.form.validation.toolingCostsRequired",
            toolingCostsMin: "request.form.validation.toolingCostsMin",
            toolingCostsMax: "request.form.validation.toolingCostsMax",
            clicheCostsRequired: "request.form.validation.clicheCostsRequired",
            clicheCostsMin: "request.form.validation.clicheCostsMin",
            clicheCostsMax: "request.form.validation.clicheCostsMax",
            seriesTotalQuantityRequired: "request.form.validation.seriesTotalQuantityRequired",
            seriesTotalQuantityMin: "request.form.validation.seriesTotalQuantityMin",
            seriesTotalQuantityMax: "request.form.validation.seriesTotalQuantityMax",
            additionalInformationMaxLength: "request.form.validation.additionalInformationMaxLength",
            deliveryAddress: "request.form.validation.deliveryAddress",
            cancellationReasonRequired: "request.form.validation.cancellationReasonRequired",
            cancellationReasonMaxLength: "request.form.validation.cancellationReasonMaxLength",
            deliveryDateOnOrAfter: "request.form.validation.deliveryDateOnOrAfter",
            quoteValidityRequired: "request.form.validation.quoteValidityRequired",
            requestValidityRequired: "request.form.validation.requestValidityRequired",
            maxCharactersLength: "request.form.validation.maxCharactersLength",
            duplicateQuantity: "request.form.validation.duplicateQuantity",
            uploadFiles: "request.form.validation.uploadFiles",
            quantityPerPalletMin: "request.form.validation.quantityPerPalletMin",
            quantityPerPalletMax: "request.form.validation.quantityPerPalletMax",
            pricePerPalletMin: "request.form.validation.pricePerPalletMin",
            pricePerPalletMax: "request.form.validation.pricePerPalletMax",
            bundlesPerPackageMin: "request.form.validation.bundlesPerPackageMin",
            bundlesPerPackageMax: "request.form.validation.bundlesPerPackageMax",
            rejectQuoteReasonRequired: "request.form.validation.rejectQuoteReasonRequired",
            rejectQuoteReasonMax: "request.form.validation.rejectQuoteReasonMax",
            feedbackRequired: "request.form.validation.feedbackRequired",
            feedbackMaxLength: "request.form.validation.feedbackMaxLength",
            confirmInternallyReasonRequired: "request.form.validation.confirmInternallyReasonRequired",
            confirmInternallyReasonMax: "request.form.validation.confirmInternallyReasonMax",
            companyRequired: "request.form.validation.companyRequired"
        },
        action: {
            addPrice: "request.form.action.addPrice"
        }
    },
    list: {
        message: {
            notFound: "request.list.message.notFound"
        },
        column: {
            quantity: "request.list.column.quantity"
        }
    },
    overview: {
        page: {
            requestsSectionTitle: "request.overview.page.requestsSectionTitle",
            ordersSectionTitle: "request.overview.page.ordersSectionTitle"
        },
        tooltip: {
            fullscreen: "request.overview.tooltip.fullscreen"
        },
        action: {
            closeFullscreen: "request.overview.action.closeFullscreen"
        }
    },
    grade: {
        table: {
            flute: "request.grade.table.flute",
            adOuterLiner: "request.grade.table.adOuterLiner",
            w1Flute: "request.grade.table.w1Flute",
            zd1Liner: "request.grade.table.zd1Liner",
            w2Flute: "request.grade.table.w2Flute",
            zd2Liner: "request.grade.table.zd2Liner",
            w3Flute: "request.grade.table.w3Flute",
            idInnerLiner: "request.grade.table.idInnerLiner",
            weightGM2: "request.grade.table.weightGM2",
            ectEdgeCrush: "request.grade.table.ectEdgeCrush",
            nf: "request.grade.table.nf",
            supplierGrade: "request.grade.table.supplierGrade",
            yourGrade: "request.grade.table.yourGrade",
            requesterGrade: "request.grade.table.requesterGrade",
            supplierGradeAccept: "request.grade.table.supplierGradeAccept"
        },
        dialog: {
            selectTitle: "request.grade.dialog.selectTitle",
            editTitle: "request.grade.dialog.editTitle",
            qualityGradeHeader: "request.grade.dialog.qualityGradeHeader",
            qualityGradeSearch: "request.grade.dialog.qualityGradeSearch",
            weightHeader: "request.grade.dialog.weightHeader",
            prowellWorksHeader: "request.grade.dialog.prowellWorksHeader",
            prowellWorksFilter: "request.grade.dialog.prowellWorksFilter",
            specialGrade: "request.grade.dialog.specialGrade",
            standardGrade: "request.grade.dialog.standardGrade",
            applyButton: "request.grade.dialog.applyButton",
            noGradesFound: "request.grade.dialog.noGradesFound",
            customGradeButton: "request.grade.dialog.customGradeButton",
            progroupGradeButton: "request.grade.dialog.progroupGradeButton"
        },
        form: {
            qualityGradeLabel: "request.grade.form.qualityGradeLabel",
            qualityGradeExample: "request.grade.form.qualityGradeExample",
            fluteLabel: "request.grade.form.fluteLabel",
            fluteExample: "request.grade.form.fluteExample",
            outerLinerLabel: "request.grade.form.outerLinerLabel",
            outerLinerExample: "request.grade.form.outerLinerExample",
            fluteOneLabel: "request.grade.form.fluteOneLabel",
            fluteOneExample: "request.grade.form.fluteOneExample",
            linerOneLabel: "request.grade.form.linerOneLabel",
            linerOneExample: "request.grade.form.linerOneExample",
            fluteTwoLabel: "request.grade.form.fluteTwoLabel",
            fluteTwoExample: "request.grade.form.fluteTwoExample",
            linerTwoLabel: "request.grade.form.linerTwoLabel",
            linerTwoExample: "request.grade.form.linerTwoExample",
            fluteThreeLabel: "request.grade.form.fluteThreeLabel",
            fluteThreeExample: "request.grade.form.fluteThreeExample",
            innerLinerLabel: "request.grade.form.innerLinerLabel",
            innerLinerExample: "request.grade.form.innerLinerExample",
            weightLabel: "request.grade.form.weightLabel",
            weightExample: "request.grade.form.weightExample",
            edgeCrushTestLabel: "request.grade.form.edgeCrushTestLabel",
            edgeCrushTestExample: "request.grade.form.edgeCrushTestExample",
            nfTypeLabel: "request.grade.form.nfTypeLabel",
            wetStrengthWasNF: "request.grade.form.wetStrengthWasNF",
            wetStrengthWasNotNF: "request.grade.form.wetStrengthWasNotNF"
        },
        validation: {
            qualityGradeRequired: "request.grade.validation.qualityGradeRequired",
            qualityGradeUnique: "request.grade.validation.qualityGradeUnique",
            fluteRequired: "request.grade.validation.fluteRequired",
            outerLinerRequired: "request.grade.validation.outerLinerRequired",
            fluteOneRequired: "request.grade.validation.fluteOneRequired",
            fluteTwoRequired: "request.grade.validation.fluteTwoRequired",
            innerLinerRequired: "request.grade.validation.innerLinerRequired",
            weightRequired: "request.grade.validation.weightRequired",
            edgeCrushTestRequired: "request.grade.validation.edgeCrushTestRequired",
            charMax: "request.grade.validation.charMax",
            charMin: "request.grade.validation.charMin",
            weightMin: "request.grade.validation.weightMin",
            weightMax: "request.grade.validation.weightMax",
            edgeCrushTestMin: "request.grade.validation.edgeCrushTestMin",
            edgeCrushTestMax: "request.grade.validation.edgeCrushTestMax"
        }
    }
};

export const QuoteI18N = {
  overview: {
    page: {
      requestsSectionTitle: "quote.overview.page.requestsSectionTitle",
      ordersSectionTitle: "quote.overview.page.ordersSectionTitle"
    },
    tooltip: {
      fullscreen: "quote.overview.tooltip.fullscreen"
    },
    action: {
      closeFullscreen: "quote.overview.action.closeFullscreen"
    }
  }
};

export const OrderI18N = {
    details: {
        action: {
            cancel: "order.details.action.cancel"
        },
        message: {
            documentDeleteFailed: "order.details.message.documentDeleteFailed",
            documentSaveFirst: "order.details.message.documentSaveFirst",
            noDocument: "order.details.message.noDocument"
        }
    },
    banner: {
        page: {
            title: "order.banner.page.title"
        },
        field: {
            deliveryDate: "order.banner.field.deliveryDate",
            proposedDeliveryDate: "order.banner.field.proposedDeliveryDate",
            confirmedDeliveryDate: "order.banner.field.confirmedDeliveryDate",
            cancellationReason: "order.banner.field.cancellationReason",
            deactivationReason: "order.banner.field.deactivationReason",
            deliveryDateRejectionReason: "order.banner.field.deliveryDateRejectionReason",
            requestStatus: "order.banner.field.requestStatus"
        },
        action: {
            confirmOrder: "order.banner.action.confirmOrder",
            advanceStatus: "order.banner.action.advanceStatus",
            confirmDelivered: "order.banner.action.confirmDelivered",
            cancelOrder: "order.banner.action.cancelOrder",
            confirmDeliveryDate: "order.banner.action.confirmDeliveryDate",
            rejectDeliveryDate: "order.banner.action.rejectDeliveryDate"
        },
        validation: {
            deliveryDateInPast: "order.banner.validation.deliveryDateInPast",
            deliveryDateTooFarInFuture: "order.banner.validation.deliveryDateTooFarInFuture"
        },
        message: {
            waitingForRequesterConfirmation: "order.banner.message.waitingForRequesterConfirmation"
        }
    },
    table: {
        column: {
            orderNumber: "order.table.column.orderNumber",
            quoteNumber: "order.table.column.quoteNumber",
            status: "order.table.column.status",
            deliveryAddress: "order.table.column.deliveryAddress",
            plannedDeliveryDates: "order.table.column.plannedDeliveryDates",
            confirmedDeliveryDate: "order.table.column.confirmedDeliveryDate",
            requesterCompanyName: "order.table.column.requesterCompanyName",
            supplierCompanyName: "order.table.column.supplierCompanyName",
            info: "order.table.column.info"
        },
        message: {
            noOrders: "order.table.message.noOrders"
        }
    },
    cancellation: {
        dialog: {
            title: "order.cancellation.dialog.title",
            message: "order.cancellation.dialog.message"
        },
        field: {
            reason: "order.cancellation.field.reason"
        },
        action: {
            confirm: "order.cancellation.action.confirm"
        }
    },
    tabs: {
        tab: {
            request: "order.tabs.tab.request"
        }
    },
    confirmOrder: {
        dialog: {
            title: "order.confirmOrder.dialog.title",
            message: "order.confirmOrder.dialog.message"
        }
    },
    confirmDeliveryProposal: {
        dialog: {
            title: "order.confirmDeliveryProposal.dialog.title",
            message: "order.confirmDeliveryProposal.dialog.message"
        }
    },
    confirmDeliveryDate: {
        dialog: {
            title: "order.confirmDeliveryDate.dialog.title",
            message: "order.confirmDeliveryDate.dialog.message"
        }
    },
    confirmDelivered: {
        dialog: {
            title: "order.confirmDelivered.dialog.title",
            message: "order.confirmDelivered.dialog.message"
        }
    },
    rejectDeliveryDate: {
        dialog: {
            title: "order.rejectDeliveryDate.dialog.title",
            message: "order.rejectDeliveryDate.dialog.message"
        },
        field: {
            reason: "order.rejectDeliveryDate.field.reason"
        }
    }
};

export const NotificationI18N = {
  emailHistory: {
    action: {
      open: "notification.emailHistory.action.open"
    },
    page: {
      title: "notification.emailHistory.page.title"
    },
    column: {
      createdAt: "notification.emailHistory.column.createdAt",
      sentAt: "notification.emailHistory.column.sentAt",
      sendStatus: "notification.emailHistory.column.sendStatus",
      sender: "notification.emailHistory.column.sender",
      recipient: "notification.emailHistory.column.recipient",
      subject: "notification.emailHistory.column.subject"
    },
    message: {
      noEmails: "notification.emailHistory.message.noEmails"
    },
    field: {
      message: "notification.emailHistory.field.message"
    }
  },
  chat: {
    panel: {
      title: "notification.chat.panel.title",
      collapse: "notification.chat.panel.collapse",
      expand: "notification.chat.panel.expand"
    },
    list: {
      system: "notification.chat.list.system",
      oneToOne: "notification.chat.list.oneToOne",
      empty: "notification.chat.list.empty"
    },
    window: {
      noSelection: "notification.chat.window.noSelection",
      markReadFailed: "notification.chat.window.markReadFailed",
      loadFailed: "notification.chat.window.loadFailed"
    },
    composer: {
      placeholder: "notification.chat.composer.placeholder",
      attach: "notification.chat.composer.attach",
      send: "notification.chat.composer.send",
      bodyTooLong: "notification.chat.composer.bodyTooLong",
      tooManyAttachments: "notification.chat.composer.tooManyAttachments",
      sendFailed: "notification.chat.composer.sendFailed"
    },
    message: {
      unreadDivider: "notification.chat.message.unreadDivider"
    },
    statusPill: {
      requestPublishedSelf: "notification.chat.statusPill.requestPublishedSelf",
      requestPublishedOther: "notification.chat.statusPill.requestPublishedOther",
      requestPublishedOther_noName: "notification.chat.statusPill.requestPublishedOther_noName",
      requestUnpublished: "notification.chat.statusPill.requestUnpublished",
      requestCancelled: "notification.chat.statusPill.requestCancelled",
      requestDeactivated: "notification.chat.statusPill.requestDeactivated",
      requestDatesExtended: "notification.chat.statusPill.requestDatesExtended",
      requestAdditionalInfoUpdatedSelf: "notification.chat.statusPill.requestAdditionalInfoUpdatedSelf",
      requestAdditionalInfoUpdatedOther: "notification.chat.statusPill.requestAdditionalInfoUpdatedOther",
      quoteSubmittedSelf: "notification.chat.statusPill.quoteSubmittedSelf",
      quoteSubmittedOther: "notification.chat.statusPill.quoteSubmittedOther",
      quoteSubmittedOther_noName: "notification.chat.statusPill.quoteSubmittedOther_noName",
      revisedQuoteSubmittedSelf: "notification.chat.statusPill.revisedQuoteSubmittedSelf",
      revisedQuoteSubmittedOther: "notification.chat.statusPill.revisedQuoteSubmittedOther",
      revisedQuoteSubmittedOther_noName: "notification.chat.statusPill.revisedQuoteSubmittedOther_noName",
      quoteRejectedSelf: "notification.chat.statusPill.quoteRejectedSelf",
      quoteRejectedOther: "notification.chat.statusPill.quoteRejectedOther",
      quoteRejectedOther_noName: "notification.chat.statusPill.quoteRejectedOther_noName",
      quoteDismissedRequesterSelf: "notification.chat.statusPill.quoteDismissedRequesterSelf",
      quoteDismissedRequesterSelf_noName: "notification.chat.statusPill.quoteDismissedRequesterSelf_noName",
      quoteDismissedLoserSelf: "notification.chat.statusPill.quoteDismissedLoserSelf",
      quoteDismissedOther: "notification.chat.statusPill.quoteDismissedOther",
      quoteDismissedOther_noName: "notification.chat.statusPill.quoteDismissedOther_noName",
      quoteNegotiationStartedSelf: "notification.chat.statusPill.quoteNegotiationStartedSelf",
      quoteNegotiationStartedSelf_noName: "notification.chat.statusPill.quoteNegotiationStartedSelf_noName",
      quoteNegotiationStartedOther: "notification.chat.statusPill.quoteNegotiationStartedOther",
      quoteNegotiationStartedOther_noName: "notification.chat.statusPill.quoteNegotiationStartedOther_noName",
      quoteWithdrawnSelf: "notification.chat.statusPill.quoteWithdrawnSelf",
      quoteWithdrawnOther: "notification.chat.statusPill.quoteWithdrawnOther",
      quoteWithdrawnOther_noName: "notification.chat.statusPill.quoteWithdrawnOther_noName",
      requestConfirmedBuyerSelf: "notification.chat.statusPill.requestConfirmedBuyerSelf",
      requestConfirmedBuyerSelf_noName: "notification.chat.statusPill.requestConfirmedBuyerSelf_noName",
      requestConfirmedWinnerSelf: "notification.chat.statusPill.requestConfirmedWinnerSelf",
      requestConfirmedOther: "notification.chat.statusPill.requestConfirmedOther",
      orderStatusChangedSelf: "notification.chat.statusPill.orderStatusChangedSelf",
      orderStatusChangedOther: "notification.chat.statusPill.orderStatusChangedOther",
      orderStatusChangedOther_noName: "notification.chat.statusPill.orderStatusChangedOther_noName",
      orderCancelledSelf: "notification.chat.statusPill.orderCancelledSelf",
      orderCancelledOther: "notification.chat.statusPill.orderCancelledOther",
      orderCancelledOther_noName: "notification.chat.statusPill.orderCancelledOther_noName",
      orderConfirmedSelf: "notification.chat.statusPill.orderConfirmedSelf",
      orderConfirmedOther: "notification.chat.statusPill.orderConfirmedOther",
      orderConfirmedOther_noName: "notification.chat.statusPill.orderConfirmedOther_noName",
      orderDeliveryDateProposedSelf: "notification.chat.statusPill.orderDeliveryDateProposedSelf",
      orderDeliveryDateProposedOther: "notification.chat.statusPill.orderDeliveryDateProposedOther",
      orderDeliveryDateProposedOther_noName: "notification.chat.statusPill.orderDeliveryDateProposedOther_noName",
      orderDeliveryDateConfirmedSelf: "notification.chat.statusPill.orderDeliveryDateConfirmedSelf",
      orderDeliveryDateConfirmedOther: "notification.chat.statusPill.orderDeliveryDateConfirmedOther",
      orderDeliveryDateConfirmedOther_noName: "notification.chat.statusPill.orderDeliveryDateConfirmedOther_noName",
      orderDeliveryDateRejectedSelf: "notification.chat.statusPill.orderDeliveryDateRejectedSelf",
      orderDeliveryDateRejectedOther: "notification.chat.statusPill.orderDeliveryDateRejectedOther",
      orderDeliveryDateRejectedOther_noName: "notification.chat.statusPill.orderDeliveryDateRejectedOther_noName",
      orderDeliveredSelf: "notification.chat.statusPill.orderDeliveredSelf",
      orderDeliveredOther: "notification.chat.statusPill.orderDeliveredOther",
      orderDeliveredOther_noName: "notification.chat.statusPill.orderDeliveredOther_noName",
      orderCancelledBySupplierSelf: "notification.chat.statusPill.orderCancelledBySupplierSelf",
      orderCancelledBySupplierOther: "notification.chat.statusPill.orderCancelledBySupplierOther",
      orderCancelledBySupplierOther_noName: "notification.chat.statusPill.orderCancelledBySupplierOther_noName",
      orderCancelledByRequesterSelf: "notification.chat.statusPill.orderCancelledByRequesterSelf",
      orderCancelledByRequesterOther: "notification.chat.statusPill.orderCancelledByRequesterOther",
      orderCancelledByRequesterOther_noName: "notification.chat.statusPill.orderCancelledByRequesterOther_noName",
      orderDeactivated: "notification.chat.statusPill.orderDeactivated",
      supplierViewed: "notification.chat.statusPill.supplierViewed",
      supplierViewed_noName: "notification.chat.statusPill.supplierViewed_noName"
    },
    attachment: {
      tooLarge: "notification.chat.attachment.tooLarge",
      invalidType: "notification.chat.attachment.invalidType",
      download: "notification.chat.attachment.download",
      downloadFailed: "notification.chat.attachment.downloadFailed"
    },
    readByTooltip: {
      unread: "notification.chat.readByTooltip.unread",
      readAt: "notification.chat.readByTooltip.readAt"
    }
  }
};

export const DeclineReasonI18N = {
  EXTERNAL_TENDER_NOT_AWARDED: "DeclineReason.EXTERNAL_TENDER_NOT_AWARDED",
  END_CUSTOMER_REQUIREMENTS_CHANGED: "DeclineReason.END_CUSTOMER_REQUIREMENTS_CHANGED",
  AWARDED_OFF_PLATFORM: "DeclineReason.AWARDED_OFF_PLATFORM",
  IN_HOUSE_PRODUCTION: "DeclineReason.IN_HOUSE_PRODUCTION",
  PRICE_NOT_COMPETITIVE: "DeclineReason.PRICE_NOT_COMPETITIVE",
  NO_REASON_GIVEN: "DeclineReason.NO_REASON_GIVEN",
  OTHER: "DeclineReason.OTHER",
  AWARDED_TO_OTHER_SUPPLIER: "DeclineReason.AWARDED_TO_OTHER_SUPPLIER",
  freeTextLabelOptional: "DeclineReason.freeTextLabelOptional",
  freeTextLabelMandatory: "DeclineReason.freeTextLabelMandatory"
};

export const PostLoginFeedbackDialogI18N = {
  titleQuestionStacked: "PostLoginFeedbackDialog.titleQuestionStacked",
  subtitle: "PostLoginFeedbackDialog.subtitle",
  confirmButton: "PostLoginFeedbackDialog.confirmButton",
  closeButtonAriaLabel: "PostLoginFeedbackDialog.closeButtonAriaLabel",
  noReasonConfirmText: "PostLoginFeedbackDialog.noReasonConfirmText",
  successMessage: "PostLoginFeedbackDialog.successMessage",
  deepLinkAriaLabel: "PostLoginFeedbackDialog.deepLinkAriaLabel",
  shareWithBidderLabel: "PostLoginFeedbackDialog.shareWithBidderLabel"
};

export const GeneralI18N = {
  yes: "General.yes",
  no: "General.no"
};

export const RequestKeyWordsI18N = {
  feedbackReasonCardTitle: "RequestKeyWords.feedbackReasonCardTitle",
  feedbackReasonLabel: "RequestKeyWords.feedbackReasonLabel",
  feedbackFreeTextLabel: "RequestKeyWords.feedbackFreeTextLabel",
  rejectQuoteReasonLabel: "RequestKeyWords.rejectQuoteReasonLabel",
  rejectQuoteReasonExplanationLabel: "RequestKeyWords.rejectQuoteReasonExplanationLabel",
  noRejectReasonAvailable: "RequestKeyWords.noRejectReasonAvailable"
};

export const OperatorViewI18N = {
    page: {
        requestsSectionTitle: "operatorView.page.requestsSectionTitle",
        ordersSectionTitle: "operatorView.page.ordersSectionTitle"
    },
    tooltip: {
        fullscreen: "operatorView.tooltip.fullscreen"
    },
    action: {
        closeFullscreen: "operatorView.action.closeFullscreen"
    }
};

/**
 * Texts shared by the request and order overview tables (#1607), the filter bar, the column-header filter
 * popovers, the page navigation and the three-state sortable column headers. Variant-specific field labels
 * (status, carton grade, ...) live in the request/order pages themselves and reuse existing keys where
 * possible (see the plan's "Standing constraints").
 */
export const OverviewTableI18N = {
    field: {
        search: "overviewTable.field.search",
        rangeFrom: "overviewTable.field.rangeFrom",
        rangeTo: "overviewTable.field.rangeTo",
        triStateAll: "overviewTable.field.triStateAll",
        hasUnreadMessages: "overviewTable.field.hasUnreadMessages",
        onlyUnreadMessages: "overviewTable.field.onlyUnreadMessages"
    },
    action: {
        reset: "overviewTable.action.reset"
    },
    pagination: {
        rowsPerPage: "overviewTable.pagination.rowsPerPage",
        displayedRows: "overviewTable.pagination.displayedRows",
        pageOfTotal: "overviewTable.pagination.pageOfTotal",
        previousPage: "overviewTable.pagination.previousPage",
        nextPage: "overviewTable.pagination.nextPage"
    },
    sort: {
        sortAscending: "overviewTable.sort.sortAscending",
        sortDescending: "overviewTable.sort.sortDescending",
        resetToDefault: "overviewTable.sort.resetToDefault"
    },
    menu: {
        filter: "overviewTable.menu.filter",
        sortAndFilter: "overviewTable.menu.sortAndFilter"
    },
    tooltip: {
        unreadMessagesTotal: "overviewTable.tooltip.unreadMessagesTotal"
    }
};

